import { TYPES } from "@actions/gift-card-actions";
import INITIAL_STATE from "./initial-state";

const giftCardReducer = (state = INITIAL_STATE.giftCardInfos, action) => {
  switch (action.type) {
    case TYPES.SET_GIFT_CARD_INFOS: {
      return action.giftCardInfos;
    }

    default:
      return state;
  }
};

export default giftCardReducer;
